import { Sheet } from "react-modal-sheet";
import "styles/components/common/bottomSheet.css";

type BottomSheetProps = {
  children: React.ReactNode;
  isOpen: boolean;
  defaultCloseButton?: boolean;
  title: string;
  onClose: () => void;
  detent?: "content-height" | "full-height";
};

const BottomSheet: React.FC<BottomSheetProps> = ({
  children,
  isOpen = false,
  defaultCloseButton = true,
  title,
  onClose,
  detent = "content-height",
}) => {
  return (
    <Sheet
      tweenConfig={{
        ease: "easeInOut",
        duration: 0.4,
      }}
      isOpen={isOpen}
      onClose={onClose}
      style={{ pointerEvents: "auto" }}
      dragVelocityThreshold={300}
      detent={detent}
    >
      <Sheet.Container
        // TODO: Create theme store
        data-theme={"thorThunder-light"}
        style={{ borderRadius: "24px 24px 0 0" }}
      >
        <Sheet.Header />
        <Sheet.Header>
          <div className="bottom-sheet-header">{title}</div>
        </Sheet.Header>
        <div className="bottom-sheet-container">
          <Sheet.Content disableDrag={true} style={{ flexGrow: 0, flex: 1 }}>
            {children}
          </Sheet.Content>
          {defaultCloseButton && (
            <div className="bottom-sheet-buttons-container">
              <button onClick={onClose}>Got It</button>
            </div>
          )}
        </div>
      </Sheet.Container>
      <Sheet.Backdrop
        onTap={() => {
          onClose();
        }}
      />
    </Sheet>
  );
};

export default BottomSheet;
